import { catchFetchDataError } from '@app/utils/performFetchData'

import { getTimezonesByLocation } from '@app/packages/api/v2/actions/timezones'
import type { Point } from '@app/packages/geo/Point'

import { locationTimezonesGetterSelector, setLocationTimezoneSlice } from '@app/store/slices/location_timezones'
import { createThunk } from '@app/store/thunk'

import { callV2Api } from './api'

export const getTimezoneByLocation = (location: Point) =>
  createThunk(async (dispatch, getState) => {
    const stored = locationTimezonesGetterSelector(getState())(location)
    if (stored) return stored
    const resp = await dispatch(callV2Api(getTimezonesByLocation(location))).catch(catchFetchDataError(dispatch, 'Timezone by location fetch failed'))
    dispatch(setLocationTimezoneSlice(location, resp.data))
    return resp.data
  })
